module.exports = __webpack_public_path__ + "media/images/weather/63_day_g-1eb9c3c098f5af2d28531a99f31c3b9a.png";